import React, { useRef } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

const Lightbox = (props) => {
  const { show = false, onClose, children } = props
  const wrapperRef = useRef()

  if (!show) return null

  const portalElement = document.getElementById('image-portal')

  return ReactDOM.createPortal(
    <>
      <div
        ref={wrapperRef}
        onClick={onClose}
        className={
          'fixed cursor-pointer overscroll-contain inset-0 bg-black bg-opacity-40 z-50'
        }
      >
        {children}
      </div>
    </>,
    portalElement
  )
}

Lightbox.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
}

export default Lightbox
